import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export const RETURN_TO_KEY = 'ngs_return_to';

/**
 * Tras iniciar sesión (incluido Google, que vuelve a la raíz), lleva al usuario
 * a la página que pidió antes, p. ej. el portal de un torneo escaneado por QR.
 */
export default function ReturnToRedirect() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    if (loading || !user) return;
    const target = localStorage.getItem(RETURN_TO_KEY);
    if (!target) return;
    localStorage.removeItem(RETURN_TO_KEY);
    // Solo rutas internas para evitar redirecciones abiertas.
    if (target.startsWith('/') && !target.startsWith('//')) navigate(target, { replace: true });
  }, [user, loading, navigate]);
  return null;
}
